/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { TranslationService } from '@gh/core-mls';
import { ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';

@Injectable()
export class ItemComponentDeleteGridDefinition extends ManualGridDefinition {

  constructor(private translationService: TranslationService) {
    super();
  }

  buildGridOptions(): GridOptions {
    return { getRowId: (params) => String(`${params.data.component}:${params.data.id}`) };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_code'),
      width: 250,
    },
      {
        field: 'name',
        headerName: this.translationService.get('lbl_description'),
        width: 500,
      }];
  }

}
